"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processUpdateOrderLine = void 0;
const orders_1 = require("../../factories/orders");
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineById_1 = require("./getOrderLineById");
const updateOrderLineVersion_1 = require("./updateOrderLineVersion");
const processUpdateOrderLine = async (supabase, order_line_id, action, order_line_config) => {
    const order_line = await (0, getOrderLineById_1.getOrderLineById)(supabase, order_line_id);
    const linked_line = await (0, orders_1.getOrderLinkedLineById)(supabase, order_line_id);
    let latest_linked_line_version = null;
    if (linked_line && linked_line.versions) {
        latest_linked_line_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(linked_line.versions);
    }
    if (!order_line.versions)
        throw new Error("No versions found");
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(order_line.versions);
    if (!latest_version)
        throw new Error("No latest version found");
    console.log(`[Processing order line ${order_line_id} with action ${action} and config ${JSON.stringify(order_line_config)}]`);
    switch (action) {
        case helpers_1.OrderLineAction.CANCELLED_UNAVAILABLE: {
            // if the order line is cancelled then we need to cancel the order line and send an email to the supplier informing them of the cancellation.
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CANCELLED_UNAVAILABLE,
            });
            break;
        }
        case helpers_1.OrderLineAction.CANCEL_LINE: {
            if (linked_line && latest_linked_line_version) {
                // if you are cancelling a line then you need to cancel the linked line as well.
                // this is because the linked line is a transfer line and it needs to be cancelled as well.
                await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                    ...latest_linked_line_version,
                    status: helpers_1.OrderLineStatus.CANCELLED,
                });
            }
            // if the order line is cancelled then we need to cancel the order line and send an email to the supplier informing them of the cancellation.
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CANCELLED,
            });
            break;
        }
        case helpers_1.OrderLineAction.UPDATE_TRANSFER_LINE_CONFIG: {
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                config: order_line_config,
            });
            break;
        }
        case helpers_1.OrderLineAction.ALTERNATE_TEE_TIME_ACCEPTED: {
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CONFIRMED,
            });
            // send email to the supplier informing them it has been confirmed.
            const tee_times_accepted_email_obj = {
                language_code: "en",
                template_id: helpers_1.EMAIL_GOLF_LINE_ALTERNATIVE_ACCEPTED,
                order_id: order_line.order_id,
                order_line_id: order_line.id,
            };
            await (0, sendEmail_1.sendEmail)(tee_times_accepted_email_obj);
            break;
        }
        case helpers_1.OrderLineAction.ALTERNATE_TEE_TIME_REJECTED: {
            // if the alternate order line is rejected then we need to cancel the order line and send an email to the supplier informing them of the cancellation.
            await (0, updateOrderLineVersion_1.updateOrderLineVersion)(supabase, {
                ...latest_version,
                status: helpers_1.OrderLineStatus.CANCELLED_REJECTED_BY_CLIENT,
            });
            // send email to the supplier informing them it has been confirmed.
            const tee_times_rejected_email_obj = {
                language_code: "en",
                template_id: helpers_1.EMAIL_GOLF_LINE_ALTERNATIVE_REJECTED,
                order_id: order_line.order_id,
                order_line_id: order_line.id,
            };
            await (0, sendEmail_1.sendEmail)(tee_times_rejected_email_obj);
            break;
        }
    }
};
exports.processUpdateOrderLine = processUpdateOrderLine;
